import { ConfigOption } from '@ngx-formly/core';
import { FormlyJournalListWidgetComponent } from './components/formly-journal-list-widget/formly-journal-list-widget.component';
import { WidgetJournalAssetsManagerComponent } from './components/widget-journal-assets-manager/widget-journal-assets-manager.component';

export const JOURNAL_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-journal-list-widget', component: FormlyJournalListWidgetComponent },
  { name: 'formly-journal-asset-manager', component: WidgetJournalAssetsManagerComponent },
]
